import { useState } from 'react';
import { useAuth } from '../../auth/contexts/AuthContext';
import { backupService } from '../services/backupService';
import { message } from 'antd';

export function useBackup() {
    const { currentUser } = useAuth();
    const [loading, setLoading] = useState(false);

    const exportData = async () => {
        if (!currentUser) throw new Error('User not authenticated');

        setLoading(true);
        try {
            const data = await backupService.exportData(currentUser.uid);
            backupService.downloadJSON(data, 'debt-manager-backup');
            return data;
        } catch (error) {
            console.error('Export error:', error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const importData = async (data) => {
        if (!currentUser) throw new Error('User not authenticated');

        setLoading(true);
        try {
            await backupService.importData(currentUser.uid, data);
        } catch (error) {
            console.error('Import error:', error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const setupAutoBackup = () => {
        if (!currentUser) throw new Error('User not authenticated');

        backupService.setupAutoBackup(currentUser.uid, () =>
            backupService.exportData(currentUser.uid)
        );
    };

    const getBackupHistory = () => {
        return backupService.getBackupHistory();
    };

    const downloadBackup = (backupId) => {
        backupService.downloadBackup(backupId);
    };

    return {
        loading,
        exportData,
        importData,
        setupAutoBackup,
        getBackupHistory,
        downloadBackup
    };
}
